import {Competition} from "../types/competitionTypes";
import axiosInstance from "./axiosInstance";

export async function getCompetitions(): Promise<Competition[]> {
    const response = await axiosInstance.get(`/competitions/getCompetitions`);
    return response.data;
}

export async function getCompetitionMatchDays(id: string): Promise<string[]> {
    const response = await axiosInstance.get(`/competitions/getMatchDays/${id}`);
    return response.data;
}